(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moodtwist-promotion-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('moodtwist-promotion')) {
    const promotions = new Set();
    let promotionTick;
    const refresh = () => promotions.forEach(element => element.refresh());
    customElements.define('moodtwist-promotion', class extends HTMLElement {
      connectedCallback() {
        this.startsAt = Number(this.dataset.start) * 1000;
        this.endsAt = Number(this.dataset.end) * 1000;
        this.ready = false;
        const clock = this.querySelector('countdown-timer');
        if (Number.isFinite(this.endsAt) && this.endsAt > 0) {
          const date = new Intl.DateTimeFormat(document.documentElement.lang || 'nl', { timeZone: 'Europe/Amsterdam', dateStyle: 'long', timeStyle: 'short' }).format(new Date(this.endsAt));
          clock.setAttribute('aria-label', clock.dataset.expiryLabel.replace('__DATE__', date));
        }
        this.hidden = true;
        customElements.whenDefined('countdown-timer-flip').then(() => {
          if (!this.isConnected) return;
          this.ready = true;
          promotions.add(this);
          this.refresh();
          if (!promotionTick) promotionTick = setInterval(refresh, 1000);
        });
      }
      refresh() {
        const now = Date.now();
        const valid = Number.isFinite(this.endsAt) && this.endsAt > 0 && Number.isFinite(this.startsAt) && this.startsAt < this.endsAt;
        const active = valid && now >= this.startsAt && now < this.endsAt && this.ready;
        this.hidden = !active;
        if (!active) return;
        const remaining = Math.max(0, Math.floor((this.endsAt - now) / 1000));
        const days = Math.floor(remaining / 86400);
        const values = { days, hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        this.querySelectorAll('countdown-timer-flip').forEach(flip => flip.updateValue(values[flip.getAttribute('type')]));
        this.querySelector('[data-days]').hidden = days === 0;
        const longDays = this.querySelector('[data-long-days]');
        longDays.hidden = days < 100;
        longDays.textContent = String(days);
        this.querySelector('countdown-timer-flip[type="days"]').hidden = days >= 100;
        this.querySelector('[data-last-minute]').hidden = remaining >= 60;
      }
      disconnectedCallback() {
        promotions.delete(this);
        if (promotions.size === 0) { clearInterval(promotionTick); promotionTick = null; }
      }
    });
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('pageshow', refresh);
  }
  } catch(e) { console.error(e); }
})();

})();
